import { Component, DoCheck, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {ValidationHelper} from '../../helper/validation.helper';

@Component({
  selector: 'control-messages',
   template: `<div *ngIf="errorMessage !== null"><mark>{{errorMessage}}</mark></div>`,
  // template: `{{errorMessage}} {{errorMessages}}`
})

// https://coryrylan.com/blog/angular-form-builder-and-validation-management
export class ControlMessageComponent {
  @Input() control: FormControl;
    constructor() { }

    get errorMessage() {
      for (const propertyName in this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) ) {
          return ValidationHelper.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
        }
      }
      return null;
    }
}
